var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconMusic = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "var(--tool-color-dark)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_2466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85776 11.5421V17.8459C6.13941 17.4104 5.25476 17.143 4.2861 17.143C1.9236 17.143 0 18.6808 0 20.5719C0 22.4629 1.9236 24.0007 4.2861 24.0007C6.6486 24.0007 8.5722 22.4629 8.5722 20.5719V11.1638L6.85776 11.5421Z",
    fill: "var(--tool-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2877 8.13696V14.417C21.5694 13.9816 20.6847 13.7141 19.7161 13.7141C17.3518 13.7141 15.43 15.252 15.43 17.143C15.43 19.034 17.3518 20.5719 19.7161 20.5719C22.0803 20.5719 24.0022 19.034 24.0022 17.143V7.75861L22.2877 8.13696Z",
    fill: "var(--tool-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9598 0.0191246C23.217 -0.0323086 23.481 0.0242679 23.6816 0.18714C23.8856 0.350011 24.0022 0.595176 24.0022 0.855771V6.22234L15.43 8.11411L6.85779 10.0059V4.28465C6.85779 3.88347 7.13724 3.53544 7.52985 3.448L22.9598 0.0191246Z",
    fill: "var(--tool-color-dark)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_2466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMusic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-music.b6d91170.svg";
export { ForwardRef as ReactComponent };